/* =========================================================================
   CONTAGEM REGRESSIVA DAS OFERTAS — só o tique-taque.

   Quem decide se o contador existe é o Liquid (tp-countdown-carrinho.liquid),
   que também escreve os primeiros números. Aqui só atualizamos de segundo em
   segundo.

   PASSADO O PRAZO, duas saídas: esconde o bloco (padrão) ou reinicia em 24h,
   se o elemento trouxer `data-tp-cdc-reinicia`. Ver o comentário longo lá
   embaixo, no ponto onde isso acontece.

   O DOM É CONSULTADO A CADA TIQUE, de propósito.
   A gaveta do carrinho é redesenhada inteira a cada mudança — o elemento do
   contador de agora não é o mesmo de daqui a pouco. Guardar a referência
   significaria atualizar um elemento que já saiu da página, e o contador
   congelaria depois da primeira alteração no carrinho. Um querySelector por
   segundo não custa nada.

   Só horas, minutos e segundos: as horas ACUMULAM, então "53h 12min 07s" em vez
   de "2 dias e 5h". Foi o pedido.
   ========================================================================= */

(function () {
  if (window.__tpCdc) return;
  window.__tpCdc = true;

  function duasCasas(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function tique() {
    var blocos = document.querySelectorAll('[data-tp-cdc]');
    for (var i = 0; i < blocos.length; i++) {
      var el = blocos[i];
      var fim = Date.parse(el.getAttribute('data-fim'));

      // Data inválida: deixa os números do servidor em paz em vez de escrever
      // NaN na tela.
      if (isNaN(fim)) continue;

      var restante = Math.floor((fim - Date.now()) / 1000);
      if (restante <= 0) {
        /* DUAS SAÍDAS no fim do prazo, e a diferença é o `data-tp-cdc-reinicia`.

           Sem o atributo (o padrão, e o que o carrinho usa): esconde o bloco.
           A oferta acabou, então o aviso dela sai da tela.

           Com o atributo: NÃO esconde nada — rola o prazo para frente em passos
           de 24h e segue contando. Foi pedido explicitamente, como medida
           provisória, para a faixa da PDP e o cronômetro da caixa não
           desaparecerem enquanto se decide o que pôr no lugar.

           Vale o mesmo aviso do tp-oferta-prazo, que faz esta conta no
           servidor: reiniciar sobre uma oferta que continua é o contador
           "evergreen" — afirma um fim que não existe (CDC art. 37, ônus da
           prova na loja no art. 38). É para sair.

           O passo é em 24h de RELÓGIO (86400s), não "mesma hora do dia
           seguinte": no horário de verão as duas coisas divergem em uma hora, e
           aqui o que importa é a duração mostrada, não a hora do fim.

           `while` e não um único `+24h`: a aba pode ficar aberta dias, ou a
           máquina hibernar, e um pulo só deixaria o prazo ainda no passado —
           então o próximo tique zeraria de novo, e o relógio ficaria travado em
           00h00min00s. */
        if (el.hasAttribute('data-tp-cdc-reinicia')) {
          /* O PASSO AGORA VEM DO ATRIBUTO, em segundos. Sem valor continua 24h,
             que e o que a faixa da PDP e o cronometro da caixa esperam -- eles
             usam a forma booleana `data-tp-cdc-reinicia` e nao podem mudar de
             comportamento por causa desta linha. A oferta relampago da vitrine
             VIP passa 10800 (3h). */
          var passo = parseInt(el.getAttribute('data-tp-cdc-reinicia'), 10) * 1000;
          if (!passo || passo < 1000) passo = 86400000;
          var agora = Date.now();
          while (fim <= agora) fim += passo;
          el.setAttribute('data-fim', new Date(fim).toISOString());
          restante = Math.floor((fim - agora) / 1000);
        } else {
          el.hidden = true;
          continue;
        }
      }

      var h = Math.floor(restante / 3600);
      var m = Math.floor((restante % 3600) / 60);
      var s = restante % 60;

      var eh = el.querySelector('[data-tp-cdc-h]');
      var em = el.querySelector('[data-tp-cdc-m]');
      var es = el.querySelector('[data-tp-cdc-s]');
      if (eh) eh.textContent = duasCasas(h);
      if (em) em.textContent = duasCasas(m);
      if (es) es.textContent = duasCasas(s);
    }
  }

  tique();
  setInterval(tique, 1000);
})();
